import { merge, of } from "rxjs";
import type { AjaxError } from "rxjs/ajax";
import { filter, mergeMap } from "rxjs/operators";
import { isActionOf } from "typesafe-actions";
import { getToken } from "../state/user/user.actions";
import { retryableFailures } from "../state/workspaces/retryableFailures";
import type { AppEpic } from "./types";

export const unauthorizedRetryEpic: AppEpic = (action$, _state$) => {
  return action$.pipe(
    filter(isActionOf(retryableFailures)),
    filter((a) => (a.payload.error as AjaxError).status === 401),
    mergeMap((action) =>
      merge(of(getToken.request()), of(action.payload.requestAction)),
    ),
  );
};
